export default function compareCaseInsensitive(s1: string, s2: string): number {
  return s1.localeCompare(s2, undefined, { sensitivity: 'base' });
}
